import { useEffect, useState } from "react";
import { Instagram } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { api, API, INSTAGRAM_URL } from "@/lib/api";

const Media = ({ item }) => {
  const src = `${API}/gallery/${item.id}/file`;
  return item.kind === "video" ? (
    <video src={src} className="h-full w-full object-cover" autoPlay muted loop playsInline />
  ) : (
    <img src={src} alt={item.caption || "MC Illusions Prints"} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
  );
};

export const Work = () => {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <section id="work" className="scroll-mt-20 border-y border-white/10 bg-navy" data-testid="work-section">
      <div className="mx-auto max-w-7xl px-5 py-20 lg:px-8">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <h2 className="font-display text-3xl sm:text-4xl">{t("work.title")}</h2>
            <p className="mt-3 text-slate-400 md:text-lg">{t("work.sub")}</p>
          </div>
          <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" className="btn-ghost" data-testid="work-instagram-btn">
            <Instagram className="h-4 w-4" /> {t("work.follow")}
          </a>
        </div>
        {items.length > 0 ? (
          <div className="mt-10 grid auto-rows-[220px] grid-cols-2 gap-4 md:grid-cols-4">
            {items.slice(0, 8).map((it, i) => (
              <figure key={it.id} className={`group relative overflow-hidden rounded-md bg-panel ${i === 0 ? "col-span-2 row-span-2" : ""}`} data-testid={`work-item-${i}`}>
                <Media item={it} />
                {it.caption && <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-ink/90 to-transparent p-3 text-sm font-semibold">{it.caption}</figcaption>}
              </figure>
            ))}
          </div>
        ) : (
          <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" data-testid="work-empty-card"
            className="mt-10 flex flex-col items-center justify-center gap-4 rounded-lg border-2 border-dashed border-white/15 p-12 text-center transition-colors hover:border-gold">
            <img src="/brand/logo-sm.png" alt="" className="h-24 w-auto opacity-90" />
            <p className="text-lg font-bold">{t("work.empty")}</p>
            <span className="inline-flex items-center gap-2 font-extrabold text-gold"><Instagram className="h-4 w-4" /> @mcillusionsprints</span>
          </a>
        )}
      </div>
    </section>
  );
};
